<template>
  <div class="newsletter-subscribe">
    <div
      v-if="showTitle"
      class="header"
    >
      <h3>{{ $t('messages_nl.newsletter.search.title') }}</h3>
    </div>
    <div
      class="content"
      v-html="JSON.parse(newsletterHtml)"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'adivare-newsletter-subscribe',
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    newsletterHtml: {
      type: String,
      default: ''
    }
  }
}
</script>
